
import $ from 'jquery';
import { connect } from 'react-redux';

/* https://github.com/Nathan-Schwartz/react-slider */
import ReactSlider from '../react-sliders';


/**
 * Wrapper für jQuery UI Slider in React
 */

export default class Slider extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        let props = this.props;

        return (
            <div className="slider-group slider-regular">
                <div className="slider-name">{props.title}</div>
                <div className="slider-min">
                    {Math.floor(props.startValue / props.scale)} {props.unit}
                </div>
                <div className="slider">
                    <ReactSlider
                        orientation='horizontal'
                        min={props.minBound}
                        max={props.maxBound}
                        step={props.step}
                        minDistance={1}
                        value={[props.startValue, props.endValue]}
                        withBars
                        pearling
                        onValueChange={this.props.handler}
                    />
                </div>
                <div className="slider-max">
                    {Math.ceil(props.endValue / props.scale)} {props.unit}
                </div>
            </div>
        );
    }
}


Slider.propTypes = {
    name: React.PropTypes.string,
    title: React.PropTypes.string,
    minBound: React.PropTypes.number,
    maxBound: React.PropTypes.number,
    startValue: React.PropTypes.number,
    endValue: React.PropTypes.number,
    unit: React.PropTypes.string,
    handler: React.PropTypes.func,
    step: React.PropTypes.number,
    scale: React.PropTypes.number,
}

Slider.defaultProps = {
    name: "default",
    title: "Empty Slider",
    minBound: 0,
    maxBound: 5,
    startValue: 0,
    endValue: 5,
    unit: "m",
    handler: (values) => {},
    step: 1,
    scale: 1,
}

import { setFilter } from '../store';

export function createBoundedSlider(key) {

    let mapStateToProps = (state) => {
        return state.sliders[key] || {};
    };

    let mapDispatchToProps = (dispatch, ownProps) => {
        return {
            handler: (values) => {
                dispatch(setFilter(ownProps.name, values));
            },
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(Slider);
}




// WEBPACK FOOTER //
// ./components/Slider.js